var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Card, Button, Table } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { fetchUserAgeDistribution, fetchUserAgeDistributionDetail } from '../../cores/api/api-dashboard';
import { formatCountNumber } from '../../utils/format-data';
import YearRangeFilter from '../../dashboard/components/filter/year-range-filter';
const AGE_GROUPS = ['18-24', '25-34', '35-44', '45-54', '55+'];
const EMPTY_CHART_STATE = {
    labels: AGE_GROUPS,
    male: [0, 0, 0, 0, 0],
    female: [0, 0, 0, 0, 0]
};
const normalizeAgeData = rawData => {
    if (!rawData) {
        return EMPTY_CHART_STATE;
    }
    const maleTotals = [];
    const femaleTotals = [];
    AGE_GROUPS.forEach(age => {
        let maleSum = 0;
        let femaleSum = 0;
        Object.values(rawData).forEach(item => {
            var _a, _b, _c, _d;
            maleSum += (_b = (_a = item === null || item === void 0 ? void 0 : item[age]) === null || _a === void 0 ? void 0 : _a.male) !== null && _b !== void 0 ? _b : 0;
            femaleSum += (_d = (_c = item === null || item === void 0 ? void 0 : item[age]) === null || _c === void 0 ? void 0 : _c.female) !== null && _d !== void 0 ? _d : 0;
        });
        maleTotals.push(maleSum);
        femaleTotals.push(femaleSum);
    });
    return {
        labels: AGE_GROUPS,
        male: maleTotals,
        female: femaleTotals
    };
};
const mergeAgeData = responses => {
    return responses.reduce((acc, current) => {
        Object.entries(current).forEach(([key, value]) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
            if (!acc[key]) {
                acc[key] = {
                    '18-24': {
                        male: (_b = (_a = value === null || value === void 0 ? void 0 : value['18-24']) === null || _a === void 0 ? void 0 : _a.male) !== null && _b !== void 0 ? _b : 0,
                        female: (_d = (_c = value === null || value === void 0 ? void 0 : value['18-24']) === null || _c === void 0 ? void 0 : _c.female) !== null && _d !== void 0 ? _d : 0
                    },
                    '25-34': {
                        male: (_f = (_e = value === null || value === void 0 ? void 0 : value['25-34']) === null || _e === void 0 ? void 0 : _e.male) !== null && _f !== void 0 ? _f : 0,
                        female: (_h = (_g = value === null || value === void 0 ? void 0 : value['25-34']) === null || _g === void 0 ? void 0 : _g.female) !== null && _h !== void 0 ? _h : 0
                    },
                    '35-44': {
                        male: (_k = (_j = value === null || value === void 0 ? void 0 : value['35-44']) === null || _j === void 0 ? void 0 : _j.male) !== null && _k !== void 0 ? _k : 0,
                        female: (_m = (_l = value === null || value === void 0 ? void 0 : value['35-44']) === null || _l === void 0 ? void 0 : _l.female) !== null && _m !== void 0 ? _m : 0
                    },
                    '45-54': {
                        male: (_p = (_o = value === null || value === void 0 ? void 0 : value['45-54']) === null || _o === void 0 ? void 0 : _o.male) !== null && _p !== void 0 ? _p : 0,
                        female: (_r = (_q = value === null || value === void 0 ? void 0 : value['45-54']) === null || _q === void 0 ? void 0 : _q.female) !== null && _r !== void 0 ? _r : 0
                    },
                    '55+': {
                        male: (_t = (_s = value === null || value === void 0 ? void 0 : value['55+']) === null || _s === void 0 ? void 0 : _s.male) !== null && _t !== void 0 ? _t : 0,
                        female: (_v = (_u = value === null || value === void 0 ? void 0 : value['55+']) === null || _u === void 0 ? void 0 : _u.female) !== null && _v !== void 0 ? _v : 0
                    }
                };
                return;
            }
            AGE_GROUPS.forEach(age => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                acc[key][age] = {
                    male: ((_b = (_a = acc[key][age]) === null || _a === void 0 ? void 0 : _a.male) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = value === null || value === void 0 ? void 0 : value[age]) === null || _c === void 0 ? void 0 : _c.male) !== null && _d !== void 0 ? _d : 0),
                    female: ((_f = (_e = acc[key][age]) === null || _e === void 0 ? void 0 : _e.female) !== null && _f !== void 0 ? _f : 0) + ((_h = (_g = value === null || value === void 0 ? void 0 : value[age]) === null || _g === void 0 ? void 0 : _g.female) !== null && _h !== void 0 ? _h : 0)
                };
            });
        });
        return acc;
    }, {});
};
export const ChartGenderAge = () => {
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState({
        mode: 'month',
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
    }), _useState4 = _slicedToArray(_useState3, 2), filters = _useState4[0], setFilters = _useState4[1];
    const _useQuery = useQuery({
        queryKey: ['user-age-distribution', filters],
        suspense: true,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (filters.mode === 'month') {
                const res = yield fetchUserAgeDistributionDetail({
                    year: filters.year,
                    month: filters.month,
                    gender: filters.gender
                });
                return normalizeAgeData((_a = res === null || res === void 0 ? void 0 : res.data) !== null && _a !== void 0 ? _a : {});
            }
            if (filters.mode === 'year') {
                const res = yield fetchUserAgeDistribution({
                    year: filters.year,
                    gender: filters.gender
                });
                return normalizeAgeData((_b = res === null || res === void 0 ? void 0 : res.data) !== null && _b !== void 0 ? _b : {});
            }
            const years = Array.from({
                length: filters.endYear - filters.startYear + 1
            }, (_, index) => filters.startYear + index);
            const responses = yield Promise.all(years.map((year) => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                const res = yield fetchUserAgeDistribution({
                    year,
                    gender: filters.gender
                });
                return (_a = res === null || res === void 0 ? void 0 : res.data) !== null && _a !== void 0 ? _a : {};
            })));
            const mergedData = mergeAgeData(responses);
            return normalizeAgeData(mergedData);
        })
    }), data = _useQuery.data;
    const chartState = data !== null && data !== void 0 ? data : EMPTY_CHART_STATE;
    const chartData = {
        labels: chartState.labels,
        datasets: [...(filters.gender !== 'female' ? [{
                    label: '男性',
                    data: chartState.male,
                    backgroundColor: '#1890ff'
                }] : []), ...(filters.gender !== 'male' ? [{
                    label: '女性',
                    data: chartState.female,
                    backgroundColor: '#ff4d4f'
                }] : [])]
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top'
            }
        },
        scales: {
            x: {
                stacked: false
            },
            y: {
                stacked: false
            }
        }
    };
    const tableColumns = [{
            title: '年齢層',
            dataIndex: 'age'
        }, {
            title: '男性ユーザー',
            dataIndex: 'male',
            render: v => formatCountNumber(v)
        }, {
            title: '女性ユーザー',
            dataIndex: 'female',
            render: v => formatCountNumber(v)
        }, {
            title: '合計',
            dataIndex: 'total',
            render: v => formatCountNumber(v)
        }];
    const tableData = chartState.labels.map((label, index) => ({
        key: label,
        age: label,
        male: chartState.male[index],
        female: chartState.female[index],
        total: chartState.male[index] + chartState.female[index]
    }));
    return /*#__PURE__*/ React.createElement(Card, {
        title: "\u7537\u5973\u5225\u30E6\u30FC\u30B6\u30FC\u5E74\u9F62\u5272\u5408",
        extra: /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-4"
        }, /*#__PURE__*/ React.createElement(YearRangeFilter, {
            onChange: setFilters
        }), /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-2"
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('chart'),
            className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
        }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('table'),
            className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
        }, "\u8868"))),
        styles: {
            body: {
                paddingTop: '4px',
                height: 470
            }
        }
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 450
        }
    }, /*#__PURE__*/ React.createElement(Bar, {
        data: chartData,
        options: options
    })) : /*#__PURE__*/ React.createElement(Table, {
        rowKey: "key",
        columns: tableColumns,
        dataSource: tableData,
        pagination: false,
        scroll: {
            y: 470
        },
        locale: {
            emptyText: 'データがありません'
        }
    }));
};
